import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { IonButton, IonButtons, IonContent, IonDatetime, IonHeader, IonIcon, IonLoading, IonModal, IonPage, IonPopover, IonRefresher, IonRefresherContent, IonTitle, IonToast, useIonViewDidEnter, useIonViewWillLeave } from '@ionic/react';
import { int } from '@zxing/library/esm/customTypings';
import dayjs from 'dayjs';
import { arrowBack, filterOutline, calendarOutline, receiptOutline, cashOutline, trendingUpOutline, walletOutline, pieChartOutline, statsChartOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import 'react-funnel-pipeline/dist/index.css';
import { Chart } from "react-google-charts";
import { useHistory } from 'react-router-dom';
import { carregarDesempenho, ResultadoDesempenho, CanalDesempenho } from '../../../../../Utils/IndicadoresDesempenho';
import { urlBasePedidos } from '../../../../../Utils/Services';

import { Toast } from '@capacitor/toast';
import { MessageContext } from '../../../../../contexts/MessageContext';
import Notificacoes from '../Notificacoes/Notificacoes';
import './Desempenho.css';

type Props = {
  recarregar: boolean;
};

const Desempenho: React.FC<Props> = (props: Props) => {

  const history = useHistory();
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");
  const [chartValoresOrdens, setChartValoresOrdens] = useState<any>({});
  const [chartFormaPagamento, setChartFormaPagamento] = useState<any>({});
  const [chartQuantidadeOrdens, setChartQuantidadeOrdens] = useState<any>({});

  const { loja, setLoja } = useContext(MessageContext);
  const { notificacoes, setNotificacoes } = useContext(MessageContext);
  const [showNotificacoes, setShowNotificacoes] = useState(false);

  const { mensagens, setMensagens } = useContext(MessageContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const [showLoading, setShowLoading] = useState(false);
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);


  const [valorTotal, setValorTotal] = useState(0);
  const [quantidadePedidos, setQuantidadePedidos] = useState(0);
  const [ticketMedio, setTicketMedio] = useState(0);
  const [lucroBrutoTotal, setLucroBrutoTotal] = useState<number | null>(null);
  const [margemMedia, setMargemMedia] = useState<number | null>(null);
  const [custoTotalState, setCustoTotalState] = useState<number | null>(null);
  const [resultadoFinanceiro, setResultadoFinanceiro] = useState<ResultadoDesempenho>();
  const [erroIndicadores, setErroIndicadores] = useState(false);
  const consultaAtual = useRef<AbortController>();
  const [ativo, setAtivo] = useState(false);
  useEffect(() => () => consultaAtual.current?.abort(), []);
  useEffect(() => {
    consultaAtual.current?.abort();
    setResultadoFinanceiro(undefined);
    if (ativo) carregarTodos();
  }, [loja, ativo]);


  const [opcaoSelecionada, setOpcaoSelecionada] = useState<any>("hoje");
  const [abrirFiltroPeriodo, setAbrirFiltroPeriodo] = useState<any>();



  const popover1 = useRef<HTMLIonPopoverElement>(null);
  const popover2 = useRef<HTMLIonPopoverElement>(null);


  const [showModalDataInicio, setShowModalDataInicio] = useState(false);
  const [showModalDataFim, setShowModalDataFim] = useState(false);


  const [dataInicio, setDataInicio] = useState<any>("Selecione");
  const [dataInicioBr, setDataInicioBr] = useState<any>("Selecione");
  const [dataFim, setDataFim] = useState<any>("Selecione");
  const [dataFimBr, setDataFimBr] = useState<any>("Selecione");


  // useEffect(() => {
  //   carregarTodos();
  // }, [loja]
  // );


  const openPopoverInicio = (e: any) => {
    popover1.current!.event = e;
    setShowModalDataInicio(true);
  };

  const openPopoverFim = (e: any) => {
    popover2.current!.event = e;
    setShowModalDataFim(true);
  };




  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
    setAtivo(true);
  });
  useIonViewWillLeave(() => {
    consultaAtual.current?.abort();
    setAtivo(false);
    setShowLoading(false);
  });




  const optionsQuantidadeOrdens = {
    fontName: 'Arial',
    backgroundColor: 'transparent',
    chartArea: { left: 60, right: 24, top: 56, bottom: 76 },
    // chartArea: { width: '50%' },
    isStacked: true,
    legend: { position: 'top', maxLines: 3, textStyle: { color: '#6d7685', fontSize: 11 } },
    colors: ['#4096b3', '#d85a00', '#16875b', '#6266e8'], // Cor para 'Ordens', 'Caixa', 'Mesas', 'Totem'
    hAxis: {
      title: 'Data',
      minValue: 0,
      textStyle: {
        fontSize: 10           // Tamanho da fonte pequeno
      },
      slantedText: true, // Permite que o texto seja inclinado
      slantedTextAngle: 90, // Ângulo de 90 graus para texto na vertical
    },
    vAxis: {
      title: 'Quantidade de Pedidos',
      textStyle: {
        fontSize: 10           // Tamanho da fonte pequeno
      },
    }
  };

  const optionsValoresOrdens = {
    fontName: 'Arial',
    backgroundColor: 'transparent',
    chartArea: { left: 60, right: 24, top: 56, bottom: 76 },
    // chartArea: { width: '50%' },
    isStacked: true,
    legend: { position: 'top', maxLines: 3, textStyle: { color: '#6d7685', fontSize: 11 } },
    colors: ['#4096b3', '#d85a00', '#16875b', '#6266e8'], // Cor para 'Ordens', 'Caixa', 'Mesas', 'Totem'
    hAxis: {
      title: 'Data',
      minValue: 0,
      textStyle: {
        fontSize: 10          // Tamanho da fonte pequeno
      },
      slantedText: true, // Permite que o texto seja inclinado
      slantedTextAngle: 90, // Ângulo de 90 graus para texto na vertical
    },
    vAxis: {
      title: 'R$',
      textStyle: {
        fontSize: 10          // Tamanho da fonte pequeno
      },
    }
  };

  // const optionsValoresOrdens = {
  //   title: 'Entradas de Pedidos do Mês',
  //   // chartArea: { width: '50%' },
  //   legend: { position: 'right', maxLines: 3 },
  //   colors: ['#1f77b4', '#ff7f0e', '#2ca02c'], // Cor para 'Ordens', 'Caixa', 'Mesas'
  //   hAxis: {
  //     title: 'Data',
  //     minValue: 0,
  //     textStyle: {
  //       fontSize: 8           // Tamanho da fonte pequeno
  //     },
  //   },
  //   vAxis: {
  //     title: 'R$',
  //     textStyle: {
  //       fontSize: 8           // Tamanho da fonte pequeno
  //     },
  //   }
  // };


  function carregarTodos() {

    carregarRelatorioOrdensSegmentada();
  }


  function addDays(date: Date, days: int) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function adicionaZeroNaData(numero: any) {
    if (numero <= 9)
      return "0" + numero;
    else
      return numero;
  }


  async function carregarRelatorioOrdensSegmentada(opcao: any = "") {
    if (!loja || !['leitura', 'edicao'].includes(acessos?.desempenho)) return;
    consultaAtual.current?.abort();
    const controller = new AbortController();
    consultaAtual.current = controller;
    setOpcaoSelecionada(opcao);
    setShowLoading(true);
    setErroIndicadores(false);
    setResultadoFinanceiro(undefined);
    const consultar = async () => {


      console.log("opcao", opcao);

      // hoje
      let dataFormatada = dayjs(new Date()).format('YYYY-MM-DD');
      setDataInicio(dataFormatada);
      let dataFormatada2 = dayjs(new Date()).format('YYYY-MM-DD');
      setDataFim(dataFormatada2);

      if (opcao == "mesatual") {

        dataFormatada = dayjs().startOf('month').format('YYYY-MM-DD');
        setDataInicio(dataFormatada);
        dataFormatada2 = dayjs(new Date()).format('YYYY-MM-DD');
        setDataFim(dataFormatada2);

      }
      else if (opcao == "ontem") {
        dataFormatada = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
        setDataInicio(dataFormatada);
        dataFormatada2 = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
        setDataFim(dataFormatada2);
      }
      else if (opcao == "ult7") {
        dataFormatada = dayjs().subtract(7, 'day').format('YYYY-MM-DD');
        setDataInicio(dataFormatada);
        dataFormatada2 = dayjs(new Date()).format('YYYY-MM-DD');
        setDataFim(dataFormatada2);
      }
      else if (opcao == "ult30dias") {
        dataFormatada = dayjs().subtract(30, 'day').format('YYYY-MM-DD');
        setDataInicio(dataFormatada);
        dataFormatada2 = dayjs(new Date()).format('YYYY-MM-DD');
        setDataFim(dataFormatada2);
      }
      // else if (opcao === "mesanterior") {
      //   // Primeiro dia do mês anterior
      //   const dtInicio = dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
      //   setDataInicio(dtInicio);

      //   // Último dia do mês anterior
      //   const dtFim = dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
      //   setDataFim(dtFim);

      //   console.log("Mês anterior - Início:", dtInicio);
      //   console.log("Mês anterior - Fim:", dtFim);
      //   dataFormatada = dtInicio;
      //   dataFormatada2 = dtFim;
      // }
      else if (opcao === "custom") {





        if (dataInicioBr == "Selecione" || dataFimBr == "Selecione") {
          setTextToast("Todos os campos de data são obrigatórios.");
          setShowToast(true);
          return null;
        }

        let data1 = new Date(dataInicio).getTime();
        let data2 = new Date(dataFim).getTime();

        var msDiff = data2 - data1;
        var msDiffDay = Math.floor(msDiff / (1000 * 60 * 60 * 24));

        if (msDiffDay < 0) {
          setTextToast("Data fim não pode ser menor que Data início.");
          setShowToast(true);
          return null;
        }
        else if (msDiffDay > 31) {
          setTextToast("Intervalo da data não pode ser maior que 31 dias.");
          setShowToast(true);
          return null;
        }

        // Verificar se o intervalo é maior que 30 dias
        const diferencaDias = dayjs(dataFim).diff(dayjs(dataInicio), 'day');
        if (diferencaDias > 30) {
          Toast.show({
            text: "O período não pode ser maior que 30 dias.",
            position: "center",
            duration: "long"
          });
          return;
        }

        // Se tudo estiver válido, formata as datas
        dataFormatada = dayjs(dataInicio).format('YYYY-MM-DD');
        setDataInicio(dataFormatada);

        dataFormatada2 = dayjs(dataFim).format('YYYY-MM-DD');
        setDataFim(dataFormatada2);
      }





      console.log("dataFormatada", dataFormatada);
      console.log("dataFormatada2", dataFormatada2);

      // let dataFormatada = dayjs().startOf('month').format('YYYY-MM-DD');
      // let dataFormatada = dayjs(new Date()).format('YYYY-MM-DD');
      // let dataFormatada2 = dayjs(addDays(new Date(), +1)).format('YYYY-MM-DD');

      let token: string = "";
      const tkn = localStorage.getItem("token");
      if (typeof (tkn) === "string") {
        token = tkn;
      }

      const dados = await carregarDesempenho(urlBasePedidos.url, loja, token, dataFormatada, dataFormatada2, controller.signal);
      if (controller.signal.aborted) return;
      const canais: CanalDesempenho[] = ['projetos', 'caixa', 'comandas', 'totem'];
      const cabecalho = ['Data', localStorage.getItem('servicoTipoPlural') || 'Projetos', 'Balcão', 'Mesas', 'Totem'];
      const rotulo = (data: string) => `${data.slice(8, 10)}/${data.slice(5, 7)}`;
      setChartValoresOrdens([cabecalho, ...dados.porDia.map(dia => [rotulo(dia.data), ...canais.map(canal => dia.canais[canal].faturamento)])]);
      setChartQuantidadeOrdens([cabecalho, ...dados.porDia.map(dia => [rotulo(dia.data), ...canais.map(canal => dia.canais[canal].pedidos)])]);
      setChartFormaPagamento([['Forma de Pagamento', 'Valor Total'], ...Object.entries(dados.pagamentos)]);
      setValorTotal(dados.faturamento);
      setQuantidadePedidos(dados.pedidos);
      setTicketMedio(dados.ticketMedio);
      setLucroBrutoTotal(dados.custos.lucroBruto);
      setMargemMedia(dados.custos.margem);
      setCustoTotalState(dados.custos.custo);
      setResultadoFinanceiro(dados);
    };

    return consultar()
      .catch((err) => {
        if (controller.signal.aborted) return;
        setErroIndicadores(true);
        console.warn('Falha ao carregar Desempenho');
        setTextToast('Ocorreu um erro ao carregar os dados.');
        setShowToast(true);
      })
      .finally(() => {
        if (consultaAtual.current === controller) setShowLoading(false);
      });
  }





  function doRefresh(event: any) {
    carregarTodos();
    setTimeout(() => {
      event.detail.complete();
    }, 1200);
  }


  async function closeModalNotificacoes() {
    setShowNotificacoes(false);
  }

  async function closeModalSimpleNotificacoes() {
    setShowNotificacoes(false);
  }

  return (
    <IonPage className="desempenho-page">
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton aria-label="Voltar" onClick={() => {
              history.goBack();
            }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Desempenho</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
          <IonRefresherContent />
        </IonRefresher>
        <div className="desempenho-container">
          <div className="desempenho-heading" hidden={acessos?.desempenho != 'leitura' && acessos?.desempenho != 'edicao'}>
            <h1>Desempenho da empresa</h1>
            <p>Acompanhe as vendas, os resultados e as formas de pagamento no período selecionado.</p>
          </div>
          <section className="desempenho-filters" aria-label="Período do relatório">
            <div className="desempenho-filters-heading">
              <div><h2>Período</h2><p>Escolha um intervalo para acompanhar seus indicadores.</p></div>
              <IonButton fill="outline" className="desempenho-custom-toggle" aria-expanded={!!abrirFiltroPeriodo} aria-controls="desempenho-custom-period"
                onClick={() => { setAbrirFiltroPeriodo(!abrirFiltroPeriodo) }}>
                <IonIcon slot="start" icon={filterOutline} />Personalizar período
              </IonButton>
            </div>
            <div className="desempenho-periods" role="group" aria-label="Períodos rápidos">
                <IonButton fill="clear" className={`desempenho-period${(opcaoSelecionada === "hoje" || opcaoSelecionada === "") ? ' is-selected' : ''}`} aria-pressed={opcaoSelecionada === "hoje" || opcaoSelecionada === ""}
                  onClick={() => { carregarRelatorioOrdensSegmentada("hoje") }}>Hoje</IonButton>
                <IonButton fill="clear" className={`desempenho-period${(opcaoSelecionada === "ontem") ? ' is-selected' : ''}`} aria-pressed={opcaoSelecionada === "ontem"}
                  onClick={() => { carregarRelatorioOrdensSegmentada("ontem") }}>Ontem</IonButton>
                <IonButton fill="clear" className={`desempenho-period${(opcaoSelecionada === "ult7") ? ' is-selected' : ''}`} aria-pressed={opcaoSelecionada === "ult7"}
                  onClick={() => { carregarRelatorioOrdensSegmentada("ult7") }}>7 dias</IonButton>
                <IonButton fill="clear" className={`desempenho-period${(opcaoSelecionada === "ult30dias") ? ' is-selected' : ''}`} aria-pressed={opcaoSelecionada === "ult30dias"}
                  onClick={() => { carregarRelatorioOrdensSegmentada("ult30dias") }}>30 dias</IonButton>
                <IonButton fill="clear" className={`desempenho-period${(opcaoSelecionada === "mesatual") ? ' is-selected' : ''}`} aria-pressed={opcaoSelecionada === "mesatual"}
                  onClick={() => { carregarRelatorioOrdensSegmentada("mesatual") }}>Mês atual</IonButton>
            </div>
            <div className="desempenho-custom-period" id="desempenho-custom-period" hidden={!abrirFiltroPeriodo}>
              <div className="desempenho-date-field">
                <span id="desempenho-start-label">Data início</span>
                <button type="button" aria-labelledby="desempenho-start-label desempenho-start-value" onClick={e => { openPopoverInicio(e); }}>
                  <span id="desempenho-start-value">{dataInicioBr}</span><IonIcon icon={calendarOutline} aria-hidden="true" />
                </button>
              </div>
              <div className="desempenho-date-field">
                <span id="desempenho-end-label">Data fim</span>
                <button type="button" aria-labelledby="desempenho-end-label desempenho-end-value" onClick={e => { openPopoverFim(e); }}>
                  <span id="desempenho-end-value">{dataFimBr}</span><IonIcon icon={calendarOutline} aria-hidden="true" />
                </button>
              </div>
              <IonButton className="desempenho-apply" onClick={() => {
                    carregarRelatorioOrdensSegmentada("custom");
                  }}>Filtrar</IonButton>
            </div>
          </section>
          {erroIndicadores && <p role="alert">Não foi possível carregar os indicadores. Tente atualizar novamente.</p>}
          {/* Google Charts precisa medir textos em um bloco visível ao montar. */}
          {resultadoFinanceiro && <div>
          <section className="desempenho-metrics" aria-label="Indicadores de vendas" hidden={acessos?.desempenho != 'leitura' && acessos?.desempenho != 'edicao'}>
              <div className="desempenho-metric">
                <span className="desempenho-metric-icon is-orange"><IonIcon icon={receiptOutline} aria-hidden="true" /></span>
                <div className="desempenho-metric-text"><span>Pedidos</span><strong>{quantidadePedidos}</strong></div>
              </div>
              <div className="desempenho-metric">
                <span className="desempenho-metric-icon is-green"><IonIcon icon={cashOutline} aria-hidden="true" /></span>
                <div className="desempenho-metric-text"><span>Faturamento</span><strong>{"R$ " + Number(valorTotal).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></div>
              </div>
              <div className="desempenho-metric">
                <span className="desempenho-metric-icon is-purple"><IonIcon icon={trendingUpOutline} aria-hidden="true" /></span>
                <div className="desempenho-metric-text"><span>Ticket médio</span><strong>{"R$ " + Number(ticketMedio).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></div>
              </div>
          </section>
          {/* Novos indicadores e avisos temporariamente ocultos; dados e cálculos permanecem ativos.
          {resultadoFinanceiro && <>
            <section className="desempenho-metrics" aria-label="Recebimentos">
              {([
                ['Recebimentos registrados', resultadoFinanceiro.recebido],
                ['Em aberto identificado', resultadoFinanceiro.emAberto],
                ['Recebido a mais identificado', resultadoFinanceiro.recebidoAMais],
              ] as [string, number][]).map(([rotulo, valor]) => <div className="desempenho-metric" key={rotulo}>
                <span className="desempenho-metric-icon is-orange"><IonIcon icon={walletOutline} aria-hidden="true" /></span>
                <div className="desempenho-metric-text"><span>{rotulo}</span><strong>{valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong></div>
              </div>)}
            </section>
            <p className="desempenho-nota">O lucro bruto considera produtos após descontos, sem despesas operacionais e comissões.</p>
            {resultadoFinanceiro.custos.itensSemCusto > 0 && <p className="desempenho-nota" role="status">Resultado parcial: {resultadoFinanceiro.custos.itensSemCusto} item(ns) sem custo completo ou registro financeiro não entram em custo, lucro e margem.</p>}
            {resultadoFinanceiro.custos.itensCustoLegado > 0 && <p className="desempenho-nota">{resultadoFinanceiro.custos.itensCustoLegado} item(ns) usam custos históricos da regra anterior, preservados sem recálculo.</p>}
            {resultadoFinanceiro.qualidade.pagamentosEstimados > 0 && <p className="desempenho-nota">{resultadoFinanceiro.qualidade.pagamentosEstimados} venda(s) antiga(s) sem valor recebido separado: o total da venda é usado como referência. Diferenças de pagamento não podem ser confirmadas nesses registros.</p>}
            {resultadoFinanceiro.qualidade.pagamentosInconsistentes > 0 && <p className="desempenho-nota" role="alert">{resultadoFinanceiro.qualidade.pagamentosInconsistentes} venda(s) com pagamentos ou troco inconsistentes precisam de conferência.</p>}
          </>}
          */}
          {lucroBrutoTotal !== null && (
            <section className="desempenho-metrics" aria-label="Resultado financeiro" hidden={acessos?.desempenho != 'leitura' && acessos?.desempenho != 'edicao'}>
              <div className="desempenho-metric">
                <span className="desempenho-metric-icon is-green"><IonIcon icon={trendingUpOutline} aria-hidden="true" /></span>
                <div className="desempenho-metric-text"><span>Lucro bruto dos produtos</span><strong className={lucroBrutoTotal >= 0 ? 'is-positive' : 'is-negative'}>{"R$ " + Number(lucroBrutoTotal).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></div>
              </div>
              {custoTotalState !== null && (
              <div className="desempenho-metric">
                <span className="desempenho-metric-icon is-amber"><IonIcon icon={walletOutline} aria-hidden="true" /></span>
                <div className="desempenho-metric-text"><span>Custo dos produtos</span><strong className="is-negative">{"R$ " + Number(custoTotalState).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></div>
              </div>
              )}
              {margemMedia !== null && (
              <div className="desempenho-metric">
                <span className="desempenho-metric-icon is-purple"><IonIcon icon={pieChartOutline} aria-hidden="true" /></span>
                <div className="desempenho-metric-text"><span>Margem bruta dos produtos</span><strong>{margemMedia.toFixed(1)}%</strong></div>
              </div>
              )}
            </section>
          )}
          <div className="desempenho-charts" hidden={acessos?.desempenho != 'leitura' && acessos?.desempenho != 'edicao'}>
            <section className="desempenho-chart-card" aria-labelledby="desempenho-quantity-title">
              <div className="desempenho-chart-heading">
                <span className="desempenho-section-icon"><IonIcon icon={statsChartOutline} aria-hidden="true" /></span>
                <div><h2 id="desempenho-quantity-title">Vendas por dia</h2><p>Quantidade de pedidos por canal de venda.</p></div>
              </div>
              <Chart width="100%" height="350px" chartType="ColumnChart" data={chartQuantidadeOrdens} options={optionsQuantidadeOrdens} />
            </section>
            <section className="desempenho-chart-card" aria-labelledby="desempenho-revenue-title">
              <div className="desempenho-chart-heading">
                <span className="desempenho-section-icon"><IonIcon icon={trendingUpOutline} aria-hidden="true" /></span>
                <div><h2 id="desempenho-revenue-title">Entradas por dia</h2><p>Valores em reais por canal de venda.</p></div>
              </div>
              <Chart width="100%" height="350px" chartType="LineChart" data={chartValoresOrdens} options={optionsValoresOrdens} />
            </section>
            <section className="desempenho-chart-card desempenho-payments" aria-labelledby="desempenho-payments-title">
              <div className="desempenho-chart-heading">
                <span className="desempenho-section-icon"><IonIcon icon={walletOutline} aria-hidden="true" /></span>
                <div><h2 id="desempenho-payments-title">Formas de pagamento</h2><p>Distribuição dos valores recebidos no período.</p></div>
              </div>
              {Array.isArray(chartFormaPagamento) && chartFormaPagamento.length === 1 ? (
                <div className="desempenho-empty">
                  <IonIcon icon={walletOutline} aria-hidden="true" />
                  <h3>Nenhum pagamento no período</h3>
                  <p>Os valores por forma de pagamento aparecerão aqui quando houver registros.</p>
                </div>
              ) : (
                <Chart width="100%" height="350px" chartType="PieChart" data={chartFormaPagamento}
                  options={{
                    pieSliceText: 'value',
                    legend: { position: 'bottom', maxLines: 3, textStyle: { color: '#6d7685', fontSize: 12 } },
                    fontName: 'Arial',
                    backgroundColor: 'transparent',
                    chartArea: { left: 24, top: 24, width: '85%', height: '75%' },
                    colors: ['#d85a00', '#16875b', '#6266e8', '#d39b28', '#4096b3', '#cf687b'],
                  }} />
              )}
            </section>
          </div>
          </div>}
        </div>

        <div className="content">
          <IonModal isOpen={showNotificacoes} onDidDismiss={() => { setShowNotificacoes(false); }}>
            <Notificacoes closeAction={closeModalNotificacoes} closeActionSimple={closeModalSimpleNotificacoes}></Notificacoes>
          </IonModal>

        </div>


        <IonPopover ref={popover1}
          isOpen={showModalDataInicio}
          onDidDismiss={() => setShowModalDataInicio(false)} >
          <IonContent>
            <IonDatetime
              presentation='date'
              onIonChange={e => {

                if (e.detail.value) {
                  let data = e.detail.value.toString().substring(0, 10);
                  const dataFormatada = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
                    Date.parse(data)
                  );
                  setDataInicioBr(dataFormatada);
                  setDataInicio(data);
                }
                //setShowModalDataInicio(false);
              }}></IonDatetime>
          </IonContent>
        </IonPopover >

        <IonPopover ref={popover2}
          isOpen={showModalDataFim}
          onDidDismiss={() => setShowModalDataFim(false)} >
          <IonContent>
            <IonDatetime
              presentation='date'
              onIonChange={e => {

                if (e.detail.value) {
                  let data = e.detail.value.toString().substring(0, 10);
                  const dataFormatada = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
                    Date.parse(data)
                  );
                  setDataFimBr(dataFormatada);
                  setDataFim(data);
                }
                //setShowModalDataFim(false);
              }}></IonDatetime>
          </IonContent>
        </IonPopover >

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'

        />

      </IonContent>

    </IonPage >
  );
};

export default Desempenho;
